<template>
  <div class="wrapper">
    <div>
      <div class="logo">
        r<span class="blueText">jones</span>creative
      </div>
      <div class="tagline">
        building beautiful, modern experiences with
        <transition name="fade">
          <span v-if="displayBuzzword" class="blueText iBlock"> {{ displayBuzzword }}</span>
        </transition>
      </div>
    </div>
    <div class="footer">
      <a href="http://bitbucket.org/rjonescreative" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <path d="M38.3 18.3L21.9 1.9c-.9-.9-2.5-.9-3.4 0L15 5.3l4.3 4.3c1-.3 2.2-.1 3
          .7.8.8 1 2 .7 3l4.2 4.2c1-.3 2.2-.1 3 .7 1.1 1.1 1.1 2.9 0 4.1-1.1 1.1-2.9 1.1-4.1
          0-.8-.8-1.1-2.1-.6-3.1l-3.9-3.9v10.2c.3.1.5.3.8.5 1.1 1.1 1.1 2.9 0 4.1-1.1 1.1-3
          1.1-4.1 0-1.1-1.1-1.1-3
          0-4.1.3-.3.6-.5.9-.6V15c-.3-.1-.7-.3-.9-.6-.9-.9-1.1-2.1-.6-3.2l-4.3-4.3L2.1
          18.2c-.9.9-.9 2.5 0 3.4L18.5 38c.9.9 2.5.9 3.4 0l16.3-16.3c1-.9 1-2.5.1-3.4z"/>
        </svg>
      </a>
      <a href="mailto:ryan@rjonescreative.com" class="icon">
        <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <path d="M4.4 8.5l13.4 10.6c.6.5 1.4.7 2.3.7.8 0 1.6-.2 2.3-.7L35.6
            8.5c1.1-.8.9-1.5-.5-1.5H4.9c-1.4 0-1.6.7-.5 1.5z"/>
          <path d="M36.6 11.3L22 22.4c-.5.4-1.3.6-2 .6s-1.4-.2-2-.6L3.4 11.3c-1.1-.8-2-.4-2
            1v18.2c0 1.4 1.1 2.5 2.5 2.5h32.2c1.4 0 2.5-1.1 2.5-2.5V12.3c0-1.3-.9-1.8-2-1z"/>
        </svg>
      </a>
      <a href="http://twitter.com/rdjones" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <path d="M13.3 34.3c13.6 0 21-11.3 21-21v-1c1.4-1 2.7-2.3 3.7-3.8-1.3.6-2.7
            1-4.2 1.2 1.5-.9 2.7-2.4 3.2-4.1-1.4.8-3 1.5-4.7 1.8C31 5.9 29 5 26.9 5c-4.1
            0-7.4 3.3-7.4 7.4 0 .6.1 1.1.2 1.7-6.1-.3-11.6-3.2-15.2-7.7-.6 1.1-1 2.4-1 3.7
            0 2.6 1.3 4.8 3.3 6.1-1.2 0-2.3-.4-3.3-.9v.1C3.4 19 6 22 9.4 22.7c-.6.2-1.3.3-1.9.3-.5
            0-.9 0-1.4-.1C7 25.8 9.8 28 13 28c-2.5 2-5.7 3.2-9.2 3.2-.6 0-1.2 0-1.8-.1 3.3 2 7.1
            3.2 11.3 3.2"/>
        </svg>
      </a>
      <a href="https://www.linkedin.com/in/rjonescreative" class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
          <path d="M36.2 1H3.8C2.3 1 1 2.2 1 3.7v32.5C1 37.8 2.3 39 3.8 39h32.4c1.6 0
            2.8-1.2 2.8-2.7V3.7C39 2.2 37.7 1 36.2 1zM12.3 33.4H6.6V15.2h5.6v18.2zM9.5
            12.8c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3-.1 1.8-1.5
            3.3-3.3 3.3zm23.9 20.6h-5.6v-8.8c0-2.1 0-4.8-2.9-4.8s-3.4 2.3-3.4
            4.7v9h-5.6V15.2h5.4v2.5h.1c.8-1.4 2.6-2.9 5.3-2.9 5.7 0 6.8 3.8 6.8 8.6v10z"/>
        </svg>
      </a>
    </div>
  </div>
</template>

<script>
import globalMethods from '../mixins/global-methods';

export default {
  name: 'MainView',
  mixins: [
    globalMethods,
  ],
  data() {
    return {
      displayBuzzword: '',
      buzzwordPool: [],
      buzzwords: [
        'React',
        'TypeScript',
        'CSS3',
        'Sass',
        'HTML5',
        'ES6',
        'NextJS',
        'Vue',
        'Gulp',
        'Webpack',
        'JavaScript',
        'Git',
        'NPM',
        'Photoshop',
        'Illustrator',
        'Flutter',
      ],
    };
  },
  computed: {
  },
  methods: {
    randomBuzzword() {
      if (this.buzzwordPool.length < 1) { this.loadPool(); }
      const index = Math.floor(Math.random() * Math.floor(this.buzzwordPool.length));
      const returnWord = this.buzzwordPool[index];
      this.buzzwordPool.splice(index, 1);
      return returnWord;
    },
    rotateBuzzword() {
      setInterval(() => {
        this.setBuzzword();
      }, 1500);
    },
    setBuzzword() {
      this.displayBuzzword = '';
      setTimeout(() => {
        this.displayBuzzword = this.randomBuzzword();
      }, 500);
    },
    loadPool() {
      this.buzzwordPool = [...this.buzzwords];
    },
  },
  created() {
    this.setBuzzword();
    this.rotateBuzzword();
  },
};
</script>

<style>
  :root {
    --blue: #01a0fc;
  }
  .wrapper {
    position: relative;
    display: flex;
    flex: 1 1 auto;
    margin: 25px;
    padding: 30px;
    border-width: 2px;
    border-style: solid;
    border-image: linear-gradient(-45deg, #ffe327 0%,#01a0fc 40%,#141c29 90%);
    border-image-slice: 1;
    color: white;
  }
  .logo {
    font-size: 30px;
    text-align: left;
  }
  .tagline {
    display: block;
    margin-top: 8px;
    font-size: 14px;
    text-transform: lowercase;
    text-align: left;
    font-weight: 200;
  }
  .blueText {
    color: var(--blue);
  }
  .iBlock {
    display: inline-block;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .4s cubic-bezier(.17,.67,.83,.67);
  }
  .fade-enter, .fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
    color: transparent;
    text-shadow: 0 0 8px rgba(1,160,252,1);
  }
  .fade-leave, .fade-enter-to {
    opacity: 1;
    color: var(--blue);
    text-shadow: none;
  }
  .footer {
    display: block;
    position: absolute;
    bottom: 25px;
    right: 35px;
  }
  .icon {
    display: inline-block;
    width: 35px;
    height: 35px;
  }
  .icon + .icon {
    margin-left: 15px;
  }
  .icon svg {
    fill: none;
    stroke: #01a0fc;
    transition: all .3s ease;
  }
  .icon svg:hover {
    stroke: white;
  }
  @media (min-width: 375px) {
    .logo {
      font-size: 38px;
    }
    .tagline {
      font-size: 18px;
    }
    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
    .icon + .icon {
      margin-left: 30px;
    }
  }
  @media (min-width: 450px) {
    .logo {
      font-size: 50px;
    }
    .tagline {
      font-size: 24px;
    }
  }
  @media (min-width: 768px) {
    .logo {
      font-size: 64px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainView.vue